import { render, staticRenderFns } from "./LayerCompare.vue?vue&type=template&id=891a195a&scoped=true&"
import script from "./LayerCompare.vue?vue&type=script&lang=js&"
export * from "./LayerCompare.vue?vue&type=script&lang=js&"
import style0 from "./LayerCompare.vue?vue&type=style&index=0&id=891a195a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891a195a",
  null
  
)

export default component.exports